import { Box } from "@dropbox/dig-foundations";
import { getEventTimeString } from "@mirage/shared/util/calendar";
import i18n, { getCurrentLocale } from "@mirage/translations";
import classnames from "classnames";

import styles from "./CalendarEmptyStateImage.module.css";

export const CalendarEmptyStateImage = () => {
  const locale = getCurrentLocale();

  // Localized time string for 9:00am, the mock time shown in the SVG
  const mockTime = new Date(2025, 1, 1, 9, 0, 0, 0).toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  // Localized date string for June 27, the mock date shown in the SVG
  const mockDate = new Date(2025, 5, 27, 0, 0, 0, 0).toLocaleDateString(
    locale,
    {
      month: "short",
      day: "numeric",
    },
  );

  return (
    <Box className={styles.svgContainer}>
      <svg
        height="100%"
        width="100%"
        viewBox="0 0 395 235"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className={styles.backgroundBase}
          x="0"
          y="0"
          width="395"
          height="237"
          rx="16"
        />
        <rect
          className={styles.primaryOnBase}
          x="85"
          y="16"
          width="294"
          height="60"
          rx="8"
        />
        <rect className={styles.subtle} x="160" y="58" width="2" height="2" />
        <rect
          className={styles.borderSubtle}
          x="89"
          y="110"
          width="98"
          height="8"
          rx="4"
        />
        <rect
          className={styles.borderSubtle}
          x="89"
          y="160"
          width="111"
          height="8"
          rx="4"
        />

        <text
          className={classnames(styles.subtle, styles.bold, styles.medium)}
          x="24"
          y="40"
        >
          {i18n.t("today")}
        </text>
        <text className={classnames(styles.subtle, styles.small)} x="24" y="60">
          {mockDate}
        </text>
        <text
          className={classnames(styles.base, styles.bold, styles.medium)}
          x="93"
          y="38"
        >
          {i18n.t("calendar_empty_state_first_meeting")}
        </text>
        <text
          className={classnames(styles.subtle, styles.medium)}
          x="93"
          y="64"
        >
          {mockTime}
        </text>
        <text
          className={classnames(styles.primaryBase, styles.medium, styles.bold)}
          x="171"
          y="64"
        >
          {getEventTimeString("upcoming", 0, 5)}
        </text>
        <text
          className={classnames(styles.base, styles.medium, styles.bold)}
          x="89"
          y="102"
        >
          {i18n.t("calendar_empty_state_lunch")}
        </text>
        <text
          className={classnames(styles.base, styles.medium, styles.bold)}
          x="89"
          y="152"
        >
          {i18n.t("calendar_empty_state_team_sync")}
        </text>
      </svg>
    </Box>
  );
};
